(() => {
  const productData = document.getElementById('UsaygQuoteProduct');
  if (productData) {
    const product = JSON.parse(productData.textContent);
    const updateLink = (link) => {
        const info = document.querySelector('product-info[data-update-url="true"]');
        const variantId = info?.querySelector('form[action$="/cart/add"] [name="id"]')?.value;
        const choices = [...(info?.querySelectorAll('variant-selects input:checked, variant-selects select') || [])].map((field) => field.value);
        const variant = choices.length
          ? product.variants.find((item) => item.options.length === choices.length && item.options.every((option, index) => option === choices[index]))
          : product.variants.find((item) => String(item.id) === variantId);
        const quantity = Number(info?.querySelector('[name="quantity"]')?.value);
        const target = new URL(link.dataset.usaygQuote, window.location.origin);
        target.searchParams.set('product', product.title);
        if (variant) {
          if (variant.title !== 'Default Title') target.searchParams.set('variant', variant.title);
          if (variant.sku) target.searchParams.set('sku', variant.sku);
        }
        if (Number.isSafeInteger(quantity) && quantity > 0) {
          target.searchParams.set('quantity', `${quantity} × selected option`);
        }
        link.href = target.pathname + target.search;
    };
    const updateLinks = () => document.querySelectorAll('[data-usayg-quote]').forEach(updateLink);
    updateLinks();
    document.addEventListener('change', updateLinks);
    document.addEventListener('input', updateLinks);
    ['click', 'contextmenu'].forEach((eventName) => {
      document.addEventListener(eventName, (event) => {
        const link = event.target.closest?.('[data-usayg-quote]');
        if (link) updateLink(link);
      });
    });
    // Dawn replaces purchase controls after a variant request; refresh the new links too.
    const info = document.querySelector('product-info[data-update-url="true"]');
    if (info) new MutationObserver(updateLinks).observe(info, {childList: true, subtree: true});
  }

  const enquiry = document.getElementById('UsaygContact');
  if (!enquiry) return;
  const params = new URLSearchParams(window.location.search);
  const read = (name, limit) => (params.get(name) || '').trim().slice(0, limit);
  const product = read('product', 200);
  const variant = read('variant', 150);
  const sku = read('sku', 100);
  const productField = enquiry.querySelector('#UsaygProduct');
  if (productField && !productField.value && product) {
    productField.value = [product, variant, sku ? `SKU: ${sku}` : ''].filter(Boolean).join(' — ');
  }
  const quantityField = enquiry.querySelector('#UsaygQuantity');
  if (quantityField && !quantityField.value && product) {
    quantityField.value = read('quantity', 100);
  }
})();
